import { useState } from "react";
import { Box, Center, useDisclosure } from "@chakra-ui/react";
import { useGetAllCicoTransferQuery } from "apis";
import { CicoTransferCard, CicoTransferDetailsModal, Paginator, CircularLoader } from "components";
import { ISingleCicoTransferRo } from "interfaces";
import { MdRefresh } from "react-icons/md";

const AllCicoTransfer = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const limit = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const { data, refetch, isFetching } = useGetAllCicoTransferQuery({
    page: currentPage,
    limit,
  });

  const [modalData, setModalData] = useState<ISingleCicoTransferRo>();
  const handleOpen = (data: ISingleCicoTransferRo) => {
    setModalData(data);
    onOpen();
  };

  return (
    <Box pos="relative">
      <Center
        cursor={isFetching ? "initial" : "pointer"}
        width="40px"
        height="40px"
        borderRadius="full"
        bg="rgba(255, 255, 255, 0.99)"
        boxShadow="0px 8px 30px rgba(0, 0, 0, 0.06)"
        mb="8px"
        onClick={refetch}
      >
        {isFetching ? <CircularLoader justifyContent="left" /> : <MdRefresh fontSize="18px" />}
      </Center>

      <Box minH="45vh">
        {data?.data.map(
          ({ _id, direction, originalFiatAmount, fiatType, createdAt, cryptoType, transferStatus, cryptoVolume }, index) => {
            return (
              <CicoTransferCard
                status={transferStatus}
                _id={_id}
                key={_id}
                direction={direction}
                cryptoVolume={cryptoVolume}
                fiatAmount={originalFiatAmount}
                fiatType={fiatType}
                createdAt={createdAt}
                crypto={cryptoType}
                description="This transfer failed"
                onClick={() => handleOpen(data.data[index])}
              />
            );
          }
        )}
      </Box>

      {data && data.totalCount > limit && (
        <Paginator
          totalCount={data?.totalCount!}
          page={currentPage}
          limit={limit}
          onPageChange={(page: number) => setCurrentPage(page)}
        />
      )}

      {modalData && <CicoTransferDetailsModal isOpen={isOpen} onClose={onClose} data={modalData!} />}
    </Box>
  );
};

export default AllCicoTransfer;
